/* Searchable grid over the custom icon set. Selecting an icon assigns
   it to the slot the editor came from and returns. */
import { useState } from 'react'
import { Icon, ICON_NAMES } from '../components/Icon.jsx'

export function IconPicker({ current, onPick }) {
  const [q, setQ] = useState('')
  const list = ICON_NAMES.filter((n) => n.toLowerCase().includes(q.toLowerCase().trim()))
  return (
    <div>
      <div className="picker-hint">
        <Icon name="shapes" size={18} />
        <span>Pick an icon — it replaces the current glyph and returns to the editor.</span>
      </div>
      <input
        className="icon-search"
        placeholder="Search icons (e.g. ring, key, arrow)…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      <div className="icon-grid">
        {list.map((n) => (
          <button
            key={n}
            className={'icon-cell' + (current === n ? ' sel' : '')}
            onClick={() => onPick(n)}
          >
            <Icon name={n} size={26} />
            <span className="iname">{n}</span>
          </button>
        ))}
      </div>
      {list.length === 0 && (
        <div className="empty">
          <Icon name="search" size={26} />
          <div>No icons match “{q}”.</div>
        </div>
      )}
    </div>
  )
}
